









































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Draggable from 'vuedraggable'
import CommonModal from '@/components/common/CommonModal.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import CommonAddButton from '@/components/common/CommonAddButton.vue'
import CommonAccordion from '@/components/common/CommonAccordion.vue'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export interface Subscription {
  id: number
  name: string
  price: string
  frequency: number | null
  duration: number | null
}

export interface Duration {
  id: number
  label: string
}

export interface Frequency {
  id: number
  label: string
}

export interface Name {
  id: number
  label: string
}

export interface Price {
  id: number
  label: number
}

@Component({
  components: {
    Draggable,
    CommonModal,
    CommonButton,
    CommonAddButton,
    CommonAccordion,
  },
  computed: {
    ...mapGetters('builder', { getApp: 'getApp' }),
    ...mapGetters('buildergpt', { getGptApp: 'getApp' }),
    ...mapGetters('currency', ['getCurrency']),
  },
})
export default class BuilderSubscriptionModal extends Vue {
  activeAccordion = 0
  getApp: any
  getCurrency: any
  promoPageName = ''
  getGptApp: any
  defaultTariffs: any = []
  isPriceValid = true
  @Prop({ required: true, type: Array })
  readonly value!: Subscription[]

  @Prop({ required: false, type: String })
  readonly incomingPromoPageName!: string

  @Prop({ required: true, type: Array })
  readonly frequencies!: Frequency[]

  @Prop({ required: true, type: Array })
  readonly durations!: Duration[]
  @Prop({ type: Boolean })
  readonly isGpt!: boolean

  get isSubmitButtonDisabled(): boolean {
    if (this.isGpt) {
      return !this.isPriceValid
    }
    return !this.value.every((v) => Number(v.price) > 0 && this.promoPageName.length)
  }
  get appCurrencySymbol(): string {
    if (this.isGpt) {
      return this.getCurrency.items.find((item) => item.code === this.getGptApp.currency).symbol
    } else {
      return this.getApp?.currency?.symbol ?? '₽'
    }
  }

  private mutateValue(value: any, index: number): void {
    this.$emit(
      'input',
      this.value.map((item, i) => (i === index ? { ...item, ...value } : item))
    )
  }

  submitHandler() {
    if (this.isGpt) {
      for (let i = 0; i < this.value.length; i++) {
        if (Number(this.value[i].price) < Number(this.defaultTariffs[i].price)) {
          this.isPriceValid = false
          this.$toasted.error(
            `${this.$t('tariffCount', {
              tariff: this.$t(`subsriptions.period.${this.value[i].frequency}`),
              count: Number(this.defaultTariffs[i].price),
              currency: this.appCurrencySymbol,
            })}`
          )
        }
      }
    } else {
      this.isPriceValid = this.value.every((item) => {
        if (Number(item.price) < (this.getApp.currency.symbol === 'RUB' ? 100 : 7)) {
          this.$toasted.error(`${this.$t('tariffMinPriceRules', { price: this.getApp.currency.symbol === 'RUB' ? 100 : 7 })}${this.appCurrencySymbol}`)
          return false
        }
        return true
      })
    }

    if (this.isPriceValid) {
      this.$emit('submit')
      this.$emit('setPromoPageName', this.promoPageName)
    }
  }

  onNameInput(name: string, i: number): void {
    this.mutateValue({ name }, i)
  }

  onPriceInput(price: string, i: number): void {
    this.isPriceValid = true
    let formatPrice = Number(price) < 0 ? '0' : price
    formatPrice = Number(price) > 99999 ? '99999' : price
    this.mutateValue({ price: formatPrice }, i)
  }

  onFrequencyInput(frequency: number, i: number): void {
    this.mutateValue({ frequency }, i)
  }

  onDurationInput(duration: number, i: number): void {
    this.mutateValue({ duration }, i)
  }

  onAdd(): void {
    this.$emit('input', [
      ...this.value,
      {
        id: -Number(Date.now().toString()),
        name: '',
        frequency: null,
        duration: 1,
      },
    ])
  }

  onRemove(itemId: number): void {
    this.$emit(
      'input',
      this.value.filter(({ id }) => id !== itemId)
    )
  }
  mounted() {
    this.defaultTariffs = cloneDeep(this.value)

    if (this.incomingPromoPageName) {
      this.promoPageName = this.incomingPromoPageName
    }
  }
}
